import Colors from '@/constants/Colors';
import { ClockCircleTwoTone } from '@ant-design/icons';
import Dates from '@/constants/Dates';
import { Button, Image, Modal, Space, Statistic, Tag, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { doneLate } from '../ProgressFeedback';
import { StyledProgressDetail } from './ProgressDetail.styled';
import { Text } from '@/shared/Typography';

export default function ProgressDetail({
  progressDetail,
  onClose,
  dueDate,
  timeOffset,
}) {
  const sortedProgressDetail = progressDetail?.sort(
    (p1, p2) =>
      dayjs(p2.updatedAt).toDate().getTime() -
      dayjs(p1.updatedAt).toDate().getTime()
  );
  return (
    <Modal
      visible={true}
      onCancel={onClose}
      title="Progress detail"
      width={'80%'}
      footer={<Button onClick={onClose}>Close</Button>}
    >
      <StyledProgressDetail>
        {sortedProgressDetail?.map((progressDetailItem, idx) => {
          const updatedAt = dayjs(progressDetailItem.updatedAt);
          return (
            <div className="progress-item" key={idx}>
              <div className="numbers">
                <Statistic
                  title="Progress"
                  value={progressDetailItem.data.progress}
                  precision={0}
                  suffix="%"
                  valueStyle={{
                    color:
                      progressDetailItem.data.progress == 100
                        ? Colors.success
                        : Colors.text,
                  }}
                />
                {typeof progressDetailItem.data.correct == 'number' ? (
                  <Statistic
                    title="Correctness"
                    value={progressDetailItem.data.correct}
                    precision={0}
                    suffix="%"
                    valueStyle={{
                      color:
                        progressDetailItem.data.correct >= 50
                          ? Colors.success
                          : Colors.text,
                    }}
                  />
                ) : null}
              </div>
              <div className="answers">
                {progressDetailItem.data.answers?.length
                  ? progressDetailItem.data.answers.map((answer, idx) => {
                      const value =
                        answer.answer || answer.selected || answer.image;

                      if (
                        value === undefined ||
                        value === null ||
                        value === ''
                      ) {
                        return null;
                      }

                      return (
                        <Tag
                          key={idx}
                          color={answer.correct ? Colors.success : Colors.error}
                          className="answer-tag"
                        >
                          <Answer value={value} />
                        </Tag>
                      );
                    })
                  : null}
              </div>
              <div className="date-container">
                <div className="date">
                  <Text>{updatedAt.format(Dates.defaultFormat)}</Text>
                  {doneLate(
                    progressDetailItem.updatedAt,
                    dueDate,
                    timeOffset
                  ) && (
                    <Tooltip title="Done after due date">
                      <ClockCircleTwoTone
                        twoToneColor={Colors.red}
                        className="info"
                      />
                    </Tooltip>
                  )}
                </div>
                <div className="time">
                  {updatedAt.format(Dates.defaultTimeFormat)}
                </div>
              </div>
            </div>
          );
        })}
      </StyledProgressDetail>
    </Modal>
  );
}

function Answer({ value }) {
  const isImage = value?.includes?.(
    process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST
  );
  return isImage ? (
    <Image src={value} alt="" width={100} />
  ) : (
    <span>{value}</span>
  );
}
